import { useState, useEffect } from "react";
import * as styled from "./Modal.styled";
import ModalBlock from "./ModalBlock/ModalBlock";
import StudentsDropDown from "../StudentsDropDown/StudentsDropDown";
import Loader from "../Loader/Loader";
import axios from '../../axios'
function Modal({
  lesson,
  onClose,
  joinedLesson,
  isReschedule,
  students,
  setSelectedStudent,
  selectedStudent,
  submitReschedule,
  setSelectedCell,
  loading,
  cancelLesson,
  sumbitSlot,
  isAdmin
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [option, setOption] = useState(null);
  const [allStudents, setAllStudents] = useState([])
  

    const fetchStudents = async () => {
      try {
        const res = await axios.get(`students`);
          console.log(res)
        setAllStudents(res.data)
      
      } catch (err) {
        console.error("Помилка при отриманні останнього учня:", err);
      }
    };

 
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleOverlayClick = () => {
    onClose();
    if (isReschedule) {
      setSelectedCell(null);
    }
  };

  return (
    <styled.Overlay isVisible={isVisible} onClick={handleOverlayClick}>
      <styled.ModalContent
        isVisible={isVisible}
        onClick={(e) => e.stopPropagation()}
      >
        <styled.CloseButton onClick={handleOverlayClick}>
          &times;
        </styled.CloseButton>

        {!isReschedule ? (
          loading ? (
            <Loader />
          ) : (
            <ModalBlock
              lesson={lesson}
              joinedLesson={joinedLesson}
              cancelLesson={cancelLesson}
            />
          )
        ) : (
          <>
            {loading ? (
              <Loader />
            ) : (
              <>
                {!option ? (
                  <>
                    <styled.Title>
                      Що ви хочете зробити з обраним слотом?
                    </styled.Title>
                    <styled.Description>
                      Оберіть одну з опцій, щоб продовжити.
                    </styled.Description>
                    <styled.OptionButton
                      onClick={() => setOption("reschedule")}
                    >
                      🔁 Перенести урок існуючого учня
                    </styled.OptionButton>
                    {isAdmin && (
                      <styled.OptionButton
                        onClick={() => {
                          setOption("substitute")
                          fetchStudents()
                        }}
                      >
                        🔁 Поставити заміну
                      </styled.OptionButton>
                    )}
                    <styled.OptionButton
                      onClick={() => setOption("slot-new-student")}
                    >
                      🆕 Відкрити слот для нового учня
                    </styled.OptionButton>
                    {/* 
    <styled.OptionButton onClick={() => setOption("slot-my-student")}>
      👨‍🏫 Відкрити слот для своїх учнів
    </styled.OptionButton>
    */}
                  </>
                ) : option === "reschedule" ? (
                  <>
                    <styled.Title>Перенесення уроку</styled.Title>
                    <styled.Description>
                      Виберіть учня, для якого потрібно перенести урок на цей
                      день та час.
                    </styled.Description>
                    <StudentsDropDown
                      students={students}
                      setSelectedStudent={setSelectedStudent}
                      selectedStudent={selectedStudent}
                    />
                    <styled.JoinButton onClick={() => submitReschedule()}>
                      Підтвердити перенесення
                    </styled.JoinButton>
                  </>
                ) : option === "slot-new-student" ? (
                  <>
                    <styled.Title>Слот для нового учня</styled.Title>
                    <styled.Description>
                      Цей слот буде відкритий для потенційного пробного заняття
                      або нового регулярного учня.
                    </styled.Description>
                    <styled.JoinButton
                      onClick={() => sumbitSlot("new-student")}
                    >
                      Відкрити слот
                    </styled.JoinButton>
                  </>
                ) :  option === 'substitute' && allStudents.length > 0 ? <>
                    <styled.Title>Поставити заміну</styled.Title>
                    <styled.Description>
                      Виберіть учня, для якого потрібно перенести урок на цей
                      день та час.
                    </styled.Description>
                    <StudentsDropDown
                      students={allStudents}
                      setSelectedStudent={setSelectedStudent}
                      selectedStudent={selectedStudent}
                    />
                    <styled.JoinButton onClick={() => submitReschedule()}>
                      Підтвердити перенесення
                    </styled.JoinButton>
                  </>
                : null}
              </>
            )}
          </>
        )}
      </styled.ModalContent>
    </styled.Overlay>
  );
}

export default Modal;
